import { propTypes } from "@sanity/block-content-to-react";
import React, { useState } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './tabs.module.css';

function TabAccordionItem(props) {

    const [accordionOpen, setAccordionOpen] = useState(false);

    function toggleAccordion(id) {
        setAccordionOpen(!accordionOpen);
        $('*[data-acindex="'+id+'"] .accordionContent').slideToggle(200);
    }

    let accordionClass = styles.accordionItem + ' ' + ((accordionOpen) ? styles.accordionOpen : 'not-open');
    // let accordionClass = styles.accordionItem + ' ' + ((props.index == props.isOpen) ? styles.accordionOpen : 'not-open');

    let iconClass = 'fas fa-chevron-down';
    let contentClass = styles.accordionContent + ' accordionContent';

    return (
        <div className={accordionClass} data-acindex={props.index}>
            <div className={styles.accordionLabel} onClick = {() => {toggleAccordion(props.index)} }>
                <div className={styles.accordionIconWrap}>
                    <div className={styles.accordionIcon}>
                        <i className={iconClass}></i> 
                    </div>
                </div>
                <h4>{props.item.title}</h4>
                <div className={styles.priceLabel}>
                    {
                        (props.item.oldprice) ?
                            <s>{props.item.oldprice}</s>
                        : ``
                    }
                    <span>{props.item.price}</span>
                </div>
            </div>
            <div className={contentClass}>
                <div className={styles.contentWrap}>
                    {
                        (props.item.image) ?
                            <div className={styles.contentImage}><img src={props.item.image.image.asset.url} alt={props.item.title} /></div> :
                            ` `
                    }
                    <div className={styles.richtext}>
                        <PortableText blocks={props.item.content} />
                    </div>
                </div>
            </div>
        </div>
    );
}
  
export default TabAccordionItem;